import StagedWorkflowFile from "../../components/StagedWorkfowFile/StagedWorkflowFile"
import { ScopeWorflowSectionProps } from "./ScopeWorkflows.types"
import Alert from "../../../../components/Alert/Alert"
import {QRCodeSVG} from 'qrcode.react'
import * as htmlToImage from "html-to-image"
import { useEffect, useRef, useState } from "react"
import AddStagedWorkflowForm from "../../../../components/ScopeWorkflowForm/angular/AddScopeWorkflowForm"
import ScopeWorkflowFormType from "../../../../utils/ScopeWorkflowFormType"
import { getDate } from "../../../../utils/utils"
import ConfirmationAlert from "../../../../components/ConfirmationAlert/ConfirmationAlert"
import { MAX_QR_CODE_CHARS } from "../../../../utils/constants"
import AddPatchWorkflowForm from "../../../../components/ScopeWorkflowForm/patch/AddPatchWorkflowForm"
import "./ScopeWorkflows.css"

const ScopeWorkflowsSection = (props: ScopeWorflowSectionProps) => {

  const {
    workflows,
    claddingMaterials,
    insulationMaterials,
    locations,
    showQRCode,
    showAddAngularScopeWorkflow,
    showAddPatchScopeWorkflow,
    showSelectWorkflowType,
    selectScopeTypeX,
    selectScopeTypeY,
    selectScopeMenuRef,

    selectedWorkflows,
    selectedWorkflow,
    formType,
    scopeQRString,
    error,
    showDeleteConfirmation,
    onAddAngularWorkflowScope,
    onAddPatchWorkflowScope,
    onHideSelectWorkflowType,
    onShowDeleteConfirmation,
    onSelectWorkflow,
    onCheckWorkflow,
    onOpenWorkflow,
    onHideQRCode,
    onHideScopeWorkflow,
    onError,
    onSubmit,
    onDeleteWorkflow,
    onDuplicateWorkflow,
    canGenerateQRCode
  } = props

  const qrCodeRef = useRef(null)

  const downloadQRCode = () => {
    if (qrCodeRef.current === null) { return }
    htmlToImage
      .toPng(qrCodeRef.current)
      .then((dataUrl) => {
        const link = document.createElement("a")
        link.href = dataUrl
        link.download = "qr-code.png"
        link.click()
      })
      .catch((error) => {
        onError(error)
      })
  }

  return (
    <div className="staged-workflows-container">
      {workflows.length > 0 && (
        <div className="staged-workflows-header-container">
          <p className="workflows-result-header">WORKFLOW NAME</p>
          <p className="workflows-result-header">ASSET ID</p>
          <p className="workflows-result-header">DATE</p>
          <p className="workflows-result-header"></p>
        </div>
      )}

      {workflows.map((workflow, key) => (
        <StagedWorkflowFile
          key={key}
          filename={workflow.filename === "" ? workflow.asset_id : workflow.filename}
          pipeId={workflow.asset_id}
          isSelected={selectedWorkflow?.workflow_id === workflow.workflow_id}
          disabled={!canGenerateQRCode(key)}
          onSelect={() => onSelectWorkflow(workflow)}
          isChecked={selectedWorkflows.includes(key)}
          onCheck={() => onCheckWorkflow(key)}
          date={getDate(workflow.created_at)}
          ellipsisMenu={[
            {
              item: "Open",
              onClick: () => onOpenWorkflow(ScopeWorkflowFormType.VIEW, workflow)
            },
            {
              item: "Duplicate",
              onClick: () => onDuplicateWorkflow(workflow)
            },
            {
              item: "Edit",
              onClick: () => onOpenWorkflow(ScopeWorkflowFormType.EDIT, workflow)
            },
            {
              item: "Delete",
              onClick: () => onShowDeleteConfirmation(true)
            }
          ]}
          onDoubleClick={() => onOpenWorkflow(ScopeWorkflowFormType.VIEW, workflow)}
        />
      ))}

      {workflows.length === 0 && error === undefined && (
        <div className="no-results-container">
          <p>No existing scope workflows.</p>
        </div>
      )}

      {workflows.length === 0 && error !== undefined && (
        <div className="no-results-container">
          <p>{`Failed to fetch scope workflows: ${error.message}`}</p>
        </div>
      )}

      {showAddAngularScopeWorkflow && (
        <AddStagedWorkflowForm
          claddingMaterials={claddingMaterials}
          insulationMaterials={insulationMaterials}
          locations={locations}
          showForm={showAddAngularScopeWorkflow}
          scopeWorkflowId={selectedWorkflow?.workflow_id}
          formType={formType}
          onSubmit={onSubmit}
          onHide={onHideScopeWorkflow}
          onError={onError}
        />
      )}
      
      {showAddPatchScopeWorkflow && (
        <AddPatchWorkflowForm
          claddingMaterials={claddingMaterials}
          insulationMaterials={insulationMaterials}
          locations={locations}
          showForm={showAddPatchScopeWorkflow}
          scopeWorkflowId={selectedWorkflow?.workflow_id}
          formType={formType}
          onSubmit={onSubmit}
          onHide={onHideScopeWorkflow}
          onError={onError}
        />
      )}
      

      {showSelectWorkflowType && (
        <div 
          ref={selectScopeMenuRef}
          className="select-scope-type-container"
          style={{
            position: 'fixed',
            top: selectScopeTypeY ?? 0,
            left: selectScopeTypeX ?? 0,
            zIndex: 1000,
          }}
        >
          <p className="select-scope-option" onClick={onAddAngularWorkflowScope}>Angular workflow</p>
          <p className="select-scope-option" onClick={onAddPatchWorkflowScope}>Patch workflow (Beta)</p>
        </div>
      )}

      <div 
        className={`qr-code-blur-container ${showQRCode ? "qr-code-show" : "qr-code-hide"}`}
        onClick={onHideQRCode}
      >
        <div className="qr-code-container">
          <div className="qr-container">
            <QRCodeSVG size={450} value={scopeQRString} ref={qrCodeRef} />
          </div>
          <input className="qr-code-button" type="button" value="Download" onClick={downloadQRCode} />
          <input className="qr-code-button" type="button" value="Cancel" onClick={onHideQRCode} />
        </div>
      </div>
      

      <ConfirmationAlert
        show={showDeleteConfirmation}
        title="Delete workflow scope."
        subtitle="Are you sure you want to delete this workflow scope? This action cannot be undone."
        onConfirmText="Delete"
        onConfirm={onDeleteWorkflow}
        onCancel={() => onShowDeleteConfirmation(false)}
      />
    </div>
  )
}

export default ScopeWorkflowsSection